"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateTokenAccount = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
class CreateTokenAccount extends web3_js_1.Transaction {
    constructor(options, params) {
        const { feePayer } = options;
        const { newAccountPubkey, lamports, mint, owner } = params;
        super(options);
        this.add(web3_js_1.SystemProgram.createAccount({
            fromPubkey: feePayer,
            newAccountPubkey,
            lamports,
            space: spl_token_1.AccountLayout.span,
            programId: spl_token_1.TOKEN_PROGRAM_ID,
        }));
        this.add(spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, mint, newAccountPubkey, owner !== null && owner !== void 0 ? owner : feePayer));
    }
}
exports.CreateTokenAccount = CreateTokenAccount;
//# sourceMappingURL=createTokenAccount.js.map